import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { AdminService } from '../../shared/admin.service';


@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})

export class OrdersComponent implements OnInit {

  public dtOptions: DataTables.Settings = {};
  private token: any;
  public Orders: any = [];
  public isLoading: boolean = true;
  public transactions: any = [];
  public trackList: Array<any> = [];
  public transationForm: FormGroup;
  public changebleTransations: any = [];
  public showTransationLink: boolean = false;
  public selectedOrder: any = {};

  constructor(private adminService: AdminService, private spinner: NgxSpinnerService, private modalService: NgbModal, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {

    this.token = 'Authorization:Bearer ' + localStorage.getItem('A_accesstoken');
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    this.transationForm = this.fb.group({
      transactionStatus: ['', Validators.required],
      trackingLink: [null],
      courierServices: [null]
    });
    this.getInitialData()
  }

  private getInitialData(): void {
    this.spinner.show();
    this.isLoading = true;
    forkJoin([this.adminService.orders(this.token), this.adminService.getOrderTransactions(this.token)]).pipe(take(1)).subscribe(_ => {
      this.spinner.hide();
      this.isLoading = false;
      this.transactions = _[1];
      this.Orders = _[0];
      this.Orders.map(el => el.hideEdit = this.transactions.some(_ => _.transactionId > el.transationStatusId && _.transactionId <= (el.transationStatusId === 1 ? (el.transationStatusId + 2) : (el.transationStatusId + 1))))
    });
  }

  viewdetails(item: any): void {
    this.router.navigate(['orders/orders/view', item.orderId]);
  }

  setAssignOrder(item: any): void {
    debugger
    if(item.transationStatus == "Return") {
      this.router.navigate(['orders/return/assign', item.orderId]);
    } else {
      this.router.navigate(['orders/orders/assign', item.orderId]);
    }
  }

  editAssignOrder(item: any): void {
    this.router.navigate(['orders/orders/edit', item.orderId]);
  }


}
